import { createLazyCallbackHook } from '@confluence/loadable/entry-points/lazy-callback';

export const useLazyShowFeedbackFlag = createLazyCallbackHook(
	async () =>
		(await import(/* webpackChunkName: "loadable-showFeedbackFlag" */ './showFeedbackFlag'))
			.showCreateWithRovoModalCloseFeedbackFlagThunk,
);
